import { createTheme } from "@mui/material/styles";

// PAO's brand palette, per Chantale's Sep 2026 feedback: primary is the red
// from the "Personal Architect" logo (sampled directly from the logo file:
// #d13138).
const DefaultTheme = createTheme({
  palette: {
    primary: {
      main: "#d13138",
    },
    secondary: {
      main: "#b4d0cb",
    },
    tertiary: {
      main: "#000000",
    },
    success: {
      main: "#05862d",
    },
  },
});

export default DefaultTheme;
